// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreadCrumbs__container___Do503 {
    display: flex;
    overflow-x: auto;
    align-items: center;
    margin: 0 0 12px;
    padding: 3px 2px 6px;
    scrollbar-width: none;
    white-space: nowrap;
}

.BreadCrumbs__container___Do503::-webkit-scrollbar {
    display: none;
}

.BreadCrumbs__ancestor___RfTvi,
.BreadCrumbs__current___afpqw {
    flex: none;
    font-size: 13px;
    font-variant: small-caps;
    letter-spacing: 0.035em;
    line-height: 1.35;
}

.BreadCrumbs__ancestor___RfTvi {
    color: rgba(204, 199, 184, 0.58);
    text-decoration: none;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.9);
}

.BreadCrumbs__ancestor___RfTvi:hover,
.BreadCrumbs__ancestor___RfTvi:focus {
    color: rgba(232, 217, 173, 0.86);
    outline: none;
}

.BreadCrumbs__separator___zfkHf {
    flex: none;
    margin: 0 8px;
    color: rgba(190, 143, 51, 0.48);
    font-family: monospace;
    font-size: 14px;
    text-shadow: 0 0 5px rgba(181, 126, 25, 0.18);
}

.BreadCrumbs__current___afpqw {
    color: rgba(232, 202, 116, 0.94);
    text-shadow: 0 0 6px rgba(210, 155, 40, 0.22);
}

@media (max-width: 520px) {
    .BreadCrumbs__ancestor___RfTvi,
    .BreadCrumbs__current___afpqw {
        font-size: 12px;
    }

    .BreadCrumbs__separator___zfkHf {
        margin: 0 6px;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BreadCrumbs__container___Do503`,
	"ancestor": `BreadCrumbs__ancestor___RfTvi`,
	"current": `BreadCrumbs__current___afpqw`,
	"separator": `BreadCrumbs__separator___zfkHf`
};
module.exports = ___CSS_LOADER_EXPORT___;
